import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LimitComponentVisibility } from "go-core/components/LimitComponentVisibility";
import { ItemOrderType } from "../../../../../../../services/Api/Organization/types";

interface Props {
	watchedOrderTypes?: ItemOrderType[];
	handleSetOrderTypes: (orderTypes: ItemOrderType[]) => void;
}

const BlockProductOrderTypesCard = ({ watchedOrderTypes, handleSetOrderTypes }: Props) => {
	const finalWatchedOrderTypes = watchedOrderTypes ?? [];
	const [visible, setVisible] = useState(finalWatchedOrderTypes.length > 0);
	const { t } = useTranslation();
	const options: ItemOrderType[] = [
		ItemOrderType.DELIVERY,
		ItemOrderType.DINE_IN,
		ItemOrderType.PICK_UP,
		ItemOrderType.ROOM_SERVICE,
	];

	const handleOptionClick = (option: ItemOrderType) => {
		const newOrderTypes = [...finalWatchedOrderTypes];
		if (newOrderTypes.includes(option)) {
			const optionIndex = newOrderTypes.findIndex((orderType) => orderType === option);
			newOrderTypes.splice(optionIndex, 1);
		} else {
			newOrderTypes.push(option);
		}

		handleSetOrderTypes(newOrderTypes);
	};

	const isOptionSelected = (option: ItemOrderType) => {
		return finalWatchedOrderTypes.includes(option);
	};

	const handleChangeVisibility = (value?: boolean) => {
		if (!value) {
			handleSetOrderTypes([]);
		} else {
			handleSetOrderTypes([...options]);
		}
	};

	return (
		<LimitComponentVisibility
			defaultVisible={visible}
			id="block-product-order-types"
			legendText={t("modules.item_group.field.restrictions_on_order_types.title")}
			helpText={t("modules.item_group.field.restrictions_on_order_types.help_text")}
			isVisibleControl={visible}
			setIsVisibleControl={setVisible}
			handleChange={handleChangeVisibility}
			unlimitedContent={
				<div className="d-flex gap-2 flex-wrap restrictions-container">
					{options.map((option) => (
						<div key={option}>
							<div
								onClick={() => handleOptionClick(option)}
								className={`${isOptionSelected(option) ? "active" : ""}`}
							>
								{t(`enums.orders.types.${option}`)}
							</div>
						</div>
					))}
				</div>
			}
		/>
	);
};

export default BlockProductOrderTypesCard;
